import { useEffect, useState } from 'react';
import { useIntl } from 'react-intl';
import { useNavigate } from 'react-router-dom';
import { ROOT_PATHS } from '../../Constants';
import AgMainNavigation from '../../stories/Components/Navigations/AgMainNavigation';
import home from '../../stories/assets/home.svg';
import search from '../../stories/assets/search.svg';
import task from '../../stories/assets/task.svg';
import help from '../../stories/assets/help.svg';
import badge from '../../stories/assets/badge.svg';
import check_circle from '../../stories/assets/check_circle.svg';
import pace from '../../stories/assets/pace.svg';
import chat from '../../stories/assets/chat.svg';
import LanguageIcon from '@mui/icons-material/Language';
import ListAltOutlinedIcon from '@mui/icons-material/ListAltOutlined';
import SettingsOutlinedIcon from '@mui/icons-material/SettingsOutlined';
import { setIsOpenUnsavedModal, setMember_Redirect_URL } from '../../redux/slices/member';
import { useAppDispatch, useAppSelector } from '../../redux/hooks';
import { setLocaleIsOpenUnsavedModal } from '../../redux/slices/locales';
import { setIsOpenCertificateUnsavedModal } from '../../redux/slices/certificate';

const Sidebar = () => {
  const messages = useIntl().formatMessage;
  const address = window.location.pathname;
  const navigate = useNavigate();
  const [selected, setSelected] = useState<string>('');
  const dispatch = useAppDispatch();
  const isDirty_Member_Personal = useAppSelector(state => state.member.isDirty_Member_Personal);
  const locale_newLocaleFileUploaded = useAppSelector(state => state.language.locale_newLocaleFileUploaded);
  const hasCertificateChanged = useAppSelector(state => state.certificate.hasCertificateChanged);
  const currentPath = window.location.pathname;
  const pathRegex = /(\/(member\/|add_member)(\/(\d+))?)/;
  const handleClick = (url: string) => {
    if (isDirty_Member_Personal && currentPath.match(pathRegex)) {
      dispatch(setMember_Redirect_URL(url));
      dispatch(setIsOpenUnsavedModal(true));
    } else if (currentPath === ROOT_PATHS.LOCALISATION && locale_newLocaleFileUploaded) {
      dispatch(setMember_Redirect_URL(url));
      dispatch(setLocaleIsOpenUnsavedModal(true));
    } else if ((currentPath.startsWith(ROOT_PATHS.CERTIFICATE) || currentPath === ROOT_PATHS.ADD_CERTIFICATE) && hasCertificateChanged) {
      dispatch(setMember_Redirect_URL(url));
      dispatch(setIsOpenCertificateUnsavedModal(true));
    } else {
      navigate(url, { replace: true });
    }
  };

  useEffect(() => {
    if (!address) return;
    if (address.includes('organisations')) setSelected('organisations');
    else if (address.includes('users')) setSelected('users');
    else if (address.includes('administration')) setSelected('administration');
    else if (address.includes('search')) setSelected('search');
    else if (address.includes('staff')) setSelected('staff');
    else if (address.includes('userGuidance')) setSelected('userGuidance');
    else if (address.includes('certificates')) setSelected('certificates');
    else if (address.includes('bulkImport')) setSelected('bulkImport');
    else if (address.includes('createSession')) setSelected('createSession');
    else if (address.includes('messages')) setSelected('messages');
    else if (address.includes('surveys')) setSelected('surveys');
    else if (address.includes('custom_fields')) setSelected('custom_fields');
    else if (address.includes('asset_types')) setSelected('asset_types');
    else if (address.includes('licenses')) setSelected('licenses');
    else if (address === '/') setSelected('home');
    else setSelected('');
  }, [address]);

  const data = [
    {
      id: 'home',
      name: messages({ id: 'HOME' }),
      onClick: () => { handleClick(ROOT_PATHS.ROOT); },
      icon: <img src={home} alt='' />
    },
    {
      id: 'search',
      name: messages({ id: 'SEARCH' }),
      onClick: () => { handleClick(ROOT_PATHS.SEARCH); },
      icon: <img src={search} alt='' />
    },
    {
      id: 'staff',
      name: messages({ id: 'STAFF' }),
      onClick: () => { handleClick(ROOT_PATHS.STAFF); },
      icon: <img src={badge} alt='' />
    },
    {
      id: 'bulkImport',
      name: messages({ id: 'BULK_IMPORT' }),
      expanded: true,
      messageNumber: 5,
      sub: [
        {
          id: 'start',
          name: messages({ id: 'START' }),
          icon: <img src={pace} alt='' />,
          onClick: () => { handleClick(ROOT_PATHS.START_BULK_IMPORT); },
        }
      ]
    },
    {
      id: 'surveys',
      name: messages({ id: 'SURVEYS0' }),
      onClick: () => { handleClick(ROOT_PATHS.SURVEYS); },
      icon: <img src={check_circle} alt='' />
    },
    {
      id: 'certificates',
      name: messages({ id: 'CERTIFICATES' }),
      onClick: () => { },
      icon: <img src={task} alt='' />,
      disabled: true
    },
    {
      id: 'userGuidance',
      name: messages({ id: 'USER_GUIDANCE' }),
      onClick: () => { },
      icon: <img src={help} alt='' />,
      disabled: true
    },
    {
      id: 'messages',
      name: messages({ id: 'MESSAGES' }),
      expanded: true,
      messageNumber: 5,
      sub: [
        {
          id: 'createMessages',
          name: messages({ id: 'CREATE_MESSAGES' }),
          icon: <img src={chat} alt='' />,
          disabled: true
        }
      ]
    },
    {
      id: 'adminstration',
      name: messages({ id: 'SIDEBAR_ADMIN_FEATURES' }),
      expanded: true,
      messageNumber: 5,
      admin: true,
      sub: [
        {
          id: 'customFields',
          name: messages({ id: 'CUSTOMFIELDS' }),
          onClick: () => { },
          icon: <SettingsOutlinedIcon />, // use MUI icon instead of svg because the icon color would change when selected
          disabled: true
        },
        {
          id: 'assettypes',
          name: messages({ id: 'ASSETTYPES' }),
          icon: <ListAltOutlinedIcon />, // use MUI icon instead of svg because the icon color would change when selected
          disabled: true
        },
        {
          id: 'localisation',
          name: messages({ id: 'LOCALISATION' }),
          onClick: () => { handleClick(ROOT_PATHS.LOCALISATION); },
          icon: <LanguageIcon /> // use MUI icon instead of svg because the icon color would change when selected
        }
      ]
    }
  ];

  return <AgMainNavigation data={data} />;
};
export default Sidebar;
